import { render, staticRenderFns } from "./competency-card.vue?vue&type=template&id=199081fb&scoped=true&"
import script from "./competency-card.ts?vue&type=script&lang=ts&"
export * from "./competency-card.ts?vue&type=script&lang=ts&"
import style0 from "./competency-card.scss?vue&type=style&index=0&id=199081fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199081fb",
  null
  
)

export default component.exports